import { render, staticRenderFns } from "./registeringCompany.vue?vue&type=template&id=ae11886a&scoped=true&"
import script from "./registeringCompany.vue?vue&type=script&lang=js&"
export * from "./registeringCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae11886a",
  null
  
)

export default component.exports